<template>
  <div id="ImageUpload">
    <div class="upload-pic clearfix">
      <div class="upload-pic-item" v-for="(item,i) of picArr" :key="item">
        <img :src="item" alt :style="{height,width}" />
        <i class="upload-del" @click="delPic(i)"></i>
      </div>
      <div class="upload-file" :style="{height,width}">
        <input
          type="file"
          name="file"
          accept="image/*"
          @change="upload"
          ref="file"
          multiple
        />
        <img class="file" :src="src" alt />
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/d-upload/d-upload.css"

import { uploadImage } from '../../../../../api/index'

export default {
  name: 'd-visaflow',
  data() {
    return {
      picArr: [],
    };
  },
  props: {
    src: {
      type: String,
    },
    height:{
      type:String,
    },
    width:{
      type:String
    }
  },
  methods: {
    delPic(i) {
      this.picArr.splice(i, 1);
      this.$emit("getPicArr", this.picArr);
    },
    upload(e) {
      let files = e.target.files;
      let that = this;
      for (let i = 0; i < files.length; i++) {
        let reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = function (e) {
          uploadImage({
            file: files[i]
          }).then(res => {
            if (res.Type == "Success") {
              that.picArr.push(res.Data);
              that.$emit("getPicArr", that.picArr);
              that.$refs.file.value = null;
            }
          })

        };
      }
    },
  }
}
</script>